import React from "react";
import { useSelector } from "react-redux";
import { getPace } from "Redux/selectors/global";
import { TICK } from "Models/constants";

const useDelayedValue = <T>(
    value: T,
    tickFactor: number,
    defaultValue: T
): T => {
    const pace = useSelector(getPace);
    const [delayedValue, setDelayedValue] = React.useState<T>(defaultValue);
    const mounted = React.useRef(true);

    const timeToFactor = tickFactor * pace * TICK;

    React.useEffect(() => {
        setTimeout(() => {
            if (!mounted.current) return;
            setDelayedValue(value);
        }, timeToFactor);
    }, [value, timeToFactor, setDelayedValue]);

    React.useEffect(() => {
        return () => {
            mounted.current = false;
        };
    }, []);

    return delayedValue;
};

export default useDelayedValue;
